import { render, staticRenderFns } from "./CommunicationHistory.vue?vue&type=template&id=5dd080a7&"
import script from "./CommunicationHistory.vue?vue&type=script&lang=js&"
export * from "./CommunicationHistory.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationHistory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDataTable,VSheet})
